<template>
  <div class="country-jp" :class="$x.nsAddressForm">
    <div :class="$x.dualColumn">
      <VTextField
        ref="postalCodeField"
        v-model="address.postalCode"
        name="postalCode"
        maxlength="8"
        required
        validate-on-blur
        :persistent-hint="warning"
        :hint="warning ? t.errorLookingUpPostalCode : ''"
        :label="t.postalCodeLabel"
        :class="$x.firstCol"
        class="flex-column"
        :rules="postalCodeRules"
        @blur="onBlur"
        @input="postCodeChanged"
      ></VTextField>
      <NsSelect
        v-model="address.region"
        :items="regions"
        name="region"
        :class="[{ [$x['disabled']]: postCodeLookedUp }, $x['jp-regions']]"
        :label="t.regionLabel"
        :rules="stateRules"
        :disabled="postCodeLookedUp"
        @blur="onBlur"
        @input="addressUpdated"
      ></NsSelect>
    </div>
    <div :class="$x.dualColumn">
      <VTextField
        ref="addressCity"
        v-model="address.city"
        name="city"
        maxlength="25"
        required
        validate-on-blur
        :label="t.cityLabel"
        :class="$x.firstCol"
        class="flex-column"
        :rules="cityRules"
        :readonly="postCodeLookedUp"
        @blur="onBlur"
        @input="addressUpdated"
      ></VTextField>
      <VTextField
        ref="addressDistrict"
        v-model="address.district"
        name="district"
        maxlength="25"
        required
        validate-on-blur
        :label="t.districtLabel"
        class="flex-column"
        :rules="cityRules"
        @blur="onBlur"
        @input="addressUpdated"
      ></VTextField>
    </div>
    <VTextField
      v-model="address.address1"
      name="address1"
      maxlength="32"
      validate-on-blur
      :label="t.address1Label"
      :rules="address1JPRules"
      class="flex-column"
      @blur="onBlur"
      @input="addressUpdated"
    ></VTextField>
  </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import NsSelect from '../../NsSelect.vue';
import ADDRESS_MIXIN from '../addressMixin';
import POST_CODE_LOOKUP from '../postalCodeLookup';
import CONFIG from '../addressConfig';
import REGIONS from './regions';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
  name: 'NsAddressJp',
  components: {
    VTextField,
    NsSelect,
  },
  mixins: [ADDRESS_MIXIN, POST_CODE_LOOKUP],
  data() {
    const regionLookUp = {};
    REGIONS.forEach((region) => {
      regionLookUp[region.text] = region.value;
    });
    return {
      regions: REGIONS,
      postCodeLength: 8,
      zipFound: 'notLookedUp',
      address1JPRules: [],
      regionLookUp: regionLookUp,
      warning: false,
    };
  },
  watch: {
    zipFound() {
      if (this.zipFound === 'notFound') {
        this.warning = true;
        // this.postalCodeRules = [this.t.invalidPostalCode];
        this.address.city = '';
        this.address.district = '';
        this.$refs.postalCodeField.blur();
      } else if (this.zipFound === 'found') {
        this.warning = false;
        // this.postalCodeRules = [];
      }
    },
    t() {
      if (Object.keys(this.t).length > 0) {
        this.initJPRules();
      }
    },
  },
  mounted() {
    this.address.country = 'JP';
    this.postalCodeResetRefs = [
      this.$refs.addressCity,
      this.$refs.addressDistrict,
    ];

    if (TRANSLATIONS[this.lang]) {
      this.t = TRANSLATIONS[this.lang];
    } else {
      // If the language isn't available then get the first language in translations file
      this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
    }
    this.$emit('new-address-in-form');
    this.$on('postal-code-looked-up', (found) => {
      this.zipFound = found ? 'found' : 'notFound';
    });
  },
  methods: {
    initJPRules() {
      const illegalCharactersJPRule = (v) => {
        let illegalRegex = CONFIG['JP'].illegalCharactersRegex;
        const validation =
          !v || illegalRegex.test(v.trim()) || this.t.illegalCharacters;
        return validation;
      };
      this.address1JPRules = [illegalCharactersJPRule];
    },
  },
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.jp-regions {
  &.disabled {
    &:hover {
      cursor: not-allowed !important;
    }
    label,
    div {
      color: #272525 !important;
    }
  }
}
.nsAddressForm {
  .dualColumn {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
  }
}
</style>
